<div class="tab-holder">
  <ng-container *ngIf="activeTabState$ | async as activeTab">
    <div class="page-container connection-list-container">
      <ul ngbNav #nav="ngbNav" (navChange)="onTabChanged($event)" [activeId]="activeTab.context" class="nav-tabs">
        <li [ngbNavItem]="RelationPageTabs.LIST">
          <a ngbNavLink [attr.data-test-id]="RelationPageTabs.LIST">
            {{ pageConfig.texts.acceptedRequestsTabTitle | translate }}
            <ng-container *ngIf="totalTabItems$ | async as totalCount"> ({{ totalCount.verifiedCount }})</ng-container>
          </a>

          <ng-template ngbNavContent>
            <div class="d-flex flex-wrap justify-content-between pt-3 align-items-end">
              <div class="d-flex justify-content-between search-container align-items-end flex-grow-1">
                <div class="flex-md-grow-1 w-100 mt-2 me-3" data-test-id="wrap-search-input-field">
                  <label class="form-label" for="search-input-field">
                    {{ pageConfig.texts.searchFieldLabel | translate }}
                    <span
                      *ngIf="isMobile$ | async"
                      class="ms-1"
                      data-test-id="info-tooltip"
                      placement="bottom auto"
                      [ngbTooltip]="'USER_SEARCH_INPUT_PLACEHOLDER' | translate"
                      triggers="click:blur"
                    >
                      <img src="assets/icons/icon-info.svg" alt="info" />
                    </span>
                  </label>
                  <div>
                    <div class="position-relative">
                      <input
                        type="text"
                        class="form-control"
                        data-test-id="search-input-field"
                        [placeholder]=" ((isMobile$ | async)
                        ? 'USER_SEARCH_INPUT_PLACEHOLDER_MOBILE'
                        : 'USER_SEARCH_INPUT_PLACEHOLDER') | translate "
                        appDebounceKeyboardKeyup
                        [ngModel]="activeTab.queryKeyword"
                        (debounceKeyUp)="onKeywordChanged($event)"
                        [debounceTime]="DEBOUNCE_TIME"
                      />
                      <svg-icon
                        src="assets/icons/icon-cross.svg"
                        data-test-id="clear-btn"
                        (click)="applyDefaultParams()"
                        class="btn btn-link icon-cross"
                      ></svg-icon>
                    </div>
                  </div>
                </div>
                <app-filter-drop-down
                  *ngIf="pageConfig.filter && !activeTab.queryKeyword"
                  [hideElement]="isMobile$ | async"
                  [filter]="pageConfig.filter"
                  [selectedFilter]="selectedFilter$ | async"
                  (filterSelected)="applyFilterByCategory($event)"
                >
                </app-filter-drop-down>
              </div>
              <ng-container *ngIf="pageConfig.allowedChat && (totalTabItems$ | async) as totalCount">
                <button
                  *ngIf=" !(isMobile$ | async)"
                  class="btn btn-primary mt-2 hide-element search-container-btn"
                  type="button"
                  data-test-id="send-message-group"
                  (click)="onNavigateToMessagingPage()"
                  [disabled]="!totalCount.verifiedCount  || isChatBtnDisabled"
                >
                  <span> {{ 'SEND_MESSAGE_TO_GROUP_HINT' | translate }}</span>
                </button>
              </ng-container>
            </div>
            <div class="position-relative">
              <ng-container *ngIf="pageConfig.allowedChat && isMobile$ | async">
                <div *ngIf="(totalTabItems$ | async)?.verifiedCount && !isChatBtnDisabled" class="hide-icon mt-2">
                  <a
                    type="button"
                    class="image-button"
                    data-test-id="send-message-group-mobile"
                    (click)="onNavigateToMessagingPage()"
                  >
                    <img class="group-letter-image" src="assets/icons/icon-group-letter.svg" alt="group_letter" />
                  </a>
                </div>
              </ng-container>

              <ng-container *ngIf="activeTab.mode === ListMode.BROWSE">
                <app-grid-users-list
                  [constructorData]="tableData$ | async"
                  [isLoading]="isLoading$ | async"
                  [noUsersHint]="pageConfig.texts.noAcceptedRequestsHint"
                  [currentSortCategory]="(sortParams$ | async).orderType"
                  [ascending]="(sortParams$ | async).ascending"
                  [sortOptions]="SORT_OPTIONS"
                  [filter]="pageConfig.filter"
                  [currentFilterCategory]="selectedFilter$ | async"
                  (toggleFilteringByType)="applyFilterByCategory($event)"
                  (toggleSorting)="onSortParamChanged($event)"
                  (toggleSortingByType)="toggleSortingOrderByType($event)"
                  (action)="onTableAction($event)"
                >
                </app-grid-users-list>
              </ng-container>

              <ng-container *ngIf="activeTab.mode === ListMode.SEARCH">
                <app-grid-users-list
                  [constructorData]="searchTableData$ | async"
                  [isLoading]="isLoading$ | async"
                  [currentSortCategory]="(sortParams$ | async).orderType"
                  [ascending]="(sortParams$ | async).ascending"
                  [sortOptions]="NAME_SORT_OPTIONS"
                  (toggleSorting)="onSortParamChanged($event)"
                  (toggleSortingByType)="toggleSortingOrderByType($event)"
                  (action)="onSearchTableAction($event)"
                >
                </app-grid-users-list>
                <ng-container *ngIf="!(searchTableData$ | async)?.body.length && !(isLoading$ | async)">
                  <p
                    class="p-3"
                    [innerHTML]="'SEARCH_NO_RESULT_HINT' | translate : { keyword: activeTab.queryKeyword }"
                  ></p>
                </ng-container>
              </ng-container>
            </div>
          </ng-template>
        </li>

        <li [ngbNavItem]="RelationPageTabs.REQUESTS_SENT">
          <a ngbNavLink [attr.data-test-id]="RelationPageTabs.REQUESTS_SENT">
            {{ 'RELATION_REQUEST_SENT_TAB_HINT' | translate }}
            <ng-container *ngIf="totalTabItems$ | async as totalCount"> ({{ totalCount.requestsSent }})</ng-container>
          </a>

          <ng-template ngbNavContent>
            <div class="ps-2 pt-2">
              <app-filter-drop-down
                *ngIf="pageConfig.filter"
                [isLoading]="isLoading$ | async"
                [hideElement]="isMobile$ | async"
                [filter]="pageConfig.filter"
                [selectedFilter]="selectedFilter$ | async"
                (filterSelected)="applyFilterByCategory($event)"
              ></app-filter-drop-down>
            </div>

            <div class="position-relative">
              <app-grid-users-list
                [constructorData]="tableData$ | async"
                [isLoading]="isLoading$ | async"
                [noUsersHint]="pageConfig.texts.noSentRequestsHint"
                [currentSortCategory]="(sortParams$ | async).orderType"
                [ascending]="(sortParams$ | async).ascending"
                [sortOptions]="SORT_OPTIONS"
                [filter]="pageConfig.filter"
                [currentFilterCategory]="selectedFilter$ | async"
                (toggleFilteringByType)="applyFilterByCategory($event)"
                (toggleSorting)="onSortParamChanged($event)"
                (toggleSortingByType)="toggleSortingOrderByType($event)"
                (action)="onTableAction($event)"
              >
              </app-grid-users-list>
            </div>
          </ng-template>
        </li>

        <li [ngbNavItem]="RelationPageTabs.REQUESTS_RECEIVED">
          <a ngbNavLink [attr.data-test-id]="RelationPageTabs.REQUESTS_RECEIVED">
            {{ 'RELATION_REQUEST_GOT_TAB_HINT' | translate }}
            <ng-container *ngIf="totalTabItems$ | async as totalCount">
              ({{ totalCount.requestsReceived }})</ng-container
            >
          </a>

          <ng-template ngbTabTitle>
            {{ 'RELATION_REQUEST_GOT_TAB_HINT' | translate }}
            <ng-container *ngIf="totalTabItems$ | async as totalCount">
              ({{ totalCount.requestsReceived }})</ng-container
            >
          </ng-template>

          <ng-template ngbNavContent>
            <div class="ps-2 pt-2">
              <app-filter-drop-down
                *ngIf="pageConfig.filter"
                [isLoading]="isLoading$ | async"
                [hideElement]="isMobile$ | async"
                [filter]="pageConfig.filter"
                [selectedFilter]="selectedFilter$ | async"
                (filterSelected)="applyFilterByCategory($event)"
              ></app-filter-drop-down>
            </div>

            <app-grid-users-list
              [constructorData]="tableData$ | async"
              [isLoading]="isLoading$ | async"
              [noUsersHint]="pageConfig.texts.noReceivedRequestsHint"
              [currentSortCategory]="(sortParams$ | async).orderType"
              [ascending]="(sortParams$ | async).ascending"
              [sortOptions]="SORT_OPTIONS"
              [filter]="pageConfig.filter"
              [currentFilterCategory]="selectedFilter$ | async"
              (toggleFilteringByType)="applyFilterByCategory($event)"
              (toggleSorting)="onSortParamChanged($event)"
              (toggleSortingByType)="toggleSortingOrderByType($event)"
              (action)="onTableAction($event)"
            >
            </app-grid-users-list>
          </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="nav" class="mt-2"></div>
      <div class="mt-1">
        <ng-container *ngIf="!(isLoading$ | async) && activeTab.pagination as pagination">
          <ngb-pagination
            *ngIf="pagination.totalItemsCount > pagination.limit"
            class="w-100 d-flex justify-content-center pagination custom-pagination"
            data-test-id="pagination-box"
            [collectionSize]="pagination.totalItemsCount"
            [page]="pagination.currentPage"
            [maxSize]="3"
            [rotate]="true"
            (pageChange)="onPageChanged($event)"
          ></ngb-pagination>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
